import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';
import {
  faChevronDown,
  faComment,
  faExclamationTriangle,
  faExternalLinkAlt,
  faFileDownload,
  faFilePdf,
  faHistory,
  faInfoCircle,
  faPencilAlt,
  faPlus,
  faSearch,
  faShare,
  faSortAmountDown,
  faTable,
  faTimes,
  faTrashAlt,
  faUser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Add all the icons we use to the icon library here (this enables tree-shaking)
library.add(faChevronDown);
library.add(faExclamationTriangle);
library.add(faExternalLinkAlt);
library.add(faTable);
library.add(faFilePdf);
library.add(faInfoCircle);
library.add(faPencilAlt);
library.add(faPlus);
library.add(faTrashAlt);
library.add(faSearch);
library.add(faUser);
library.add(faFileDownload);
library.add(faSortAmountDown);
library.add(faShare);
library.add(faComment);
library.add(faTimes);
library.add(faHistory);

// Brand icons
library.add(faFacebookF);
library.add(faTwitter);

Vue.component('font-awesome-icon', FontAwesomeIcon);
